import {CookieChecker} from "../components";

export const withCookieChecker = (Body, cookieProps = {}) => {
  return (props) => (
    <>
      <Body {...props}/>
      <CookieChecker {...cookieProps}/>
    </>
  );
}